module.exports = __webpack_public_path__ + "img/zhiyin.278d2f8f.png";